module.exports = __webpack_public_path__ + "static/media/vip_learn.886c5339.svg";